import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * "Elige tu Mizu" (home). Decisión 23 julio: los botones "Comprar" de Negro y Blanco añaden
 * la variante directo al carrito -sin pasar por la ficha-, porque no hay ninguna decisión que
 * tomar (la fuente no tiene modo de suscripción propio). Filtros no usa este componente: ese
 * botón sigue siendo un enlace normal a la ficha, porque ahí sí hay que elegir entre
 * suscribirse o compra única.
 */
class KotashiModelos extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#alClicComprar);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#alClicComprar);
  }

  #alClicComprar = async (evento) => {
    const boton = evento.target.closest('[data-anadir]');
    if (!boton || boton.getAttribute('aria-busy') === 'true') return;

    const variantId = boton.dataset.variantId;
    if (!variantId) return;

    const textoOriginal = boton.textContent.trim();
    boton.setAttribute('aria-busy', 'true');
    boton.textContent = 'Añadiendo…';

    const diferido = CartLinesUpdateEvent.createPromise();
    boton.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: diferido.promise,
      })
    );

    try {
      const respuesta = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      const datos = await respuesta.json();

      if (!respuesta.ok || datos.status) {
        throw new Error(datos.description || datos.message || 'No se ha podido añadir al carrito.');
      }

      const carrito = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: {
          items: carrito.items,
          source: 'kotashi-modelos',
          sourceId: 'kotashi-modelos',
          itemCount: 1,
          didError: false,
        },
      });

      boton.textContent = 'Añadido';
      setTimeout(() => {
        boton.textContent = textoOriginal;
        boton.removeAttribute('aria-busy');
      }, 1200);
    } catch (error) {
      diferido.reject(error);
      boton.textContent = 'Error, prueba de nuevo';
      console.error('[kotashi-modelos]', error);
      setTimeout(() => {
        boton.textContent = textoOriginal;
        boton.removeAttribute('aria-busy');
      }, 2000);
    }
  };
}

if (!customElements.get('kotashi-modelos')) {
  customElements.define('kotashi-modelos', KotashiModelos);
}
